<template>
    <v-dialog
        v-model="dialog" 
        persistent
        scrollable
        max-width="500px"
        transition="dialog-transition">
        <template v-slot:activator="{ on }">
            <v-btn color="#0B3F67" dark v-on="on">Agregar<v-icon right>mdi-plus-box-outline</v-icon></v-btn>
        </template>
         <v-card :loading="loading">
             <v-card-title class="pa-0">
               <ModalTitle titulo="Agregar Estructura Legal" @cancelar="cancelar"/>
            </v-card-title>  
            <v-divider />
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-text-field label="Nombre"
                        v-model="estructura.nombre"
                        :error-messages="nameErrors"
                        @input="$v.estructura.nombre.$touch()"
                        @blur="$v.estructura.nombre.$touch()"
                        required>
                        </v-text-field>
                    </v-col>
                    <!-- <v-col cols="12">
                        <v-textarea label="Descripción"
                        v-model="estructura.descripcion"
                        @input="$v.estructura.descripcion.$touch()"
                        @blur="$v.estructura.descripcion.$touch()"
                        counter="100"
                        hint="Campo Opcional"
                        outlined
                        shaped>
                        </v-textarea>
                    </v-col> -->
                </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text :disabled="loading" color="error" @click="cancelar">Cancelar</v-btn>
                <v-btn text :loading="loading" color="#0B3F67" @click="agregarEstructura">Agregar</v-btn>
            </v-card-actions>
         </v-card>      
    </v-dialog>    
</template>

<script>
import axios from "@/axios.js";
import {required, email} from "vuelidate/lib/validators";
import ModalTitle from '@/components/utils/ModalTitleComponent'
export default {
    created() {
        axios.defaults.headers.common['Authorization'] = "Bearer " + this.$store.getters.token;
    },     
    components: {
      ModalTitle
    },
    computed: {
        nameErrors () {
            const errors = []
            if (!this.$v.estructura.nombre.$dirty) return errors            
            !this.$v.estructura.nombre.required && errors.push('El nombre es requerido.')
            return errors
        },
    },
    data: () => ({
        dialog: false,
        loading: false,
        estructura: {
            nombre: '',
            //descripcion: '',    
        },        
    }),
    validations: {
        estructura: {  
            nombre: {
                required
            },
        }
    },
    methods:{
        cancelar() {
            this.estructura = {};
            this.dialog = false;      
            this.loading = false;      
            this.$v.estructura.$reset();
        },
        agregarEstructura() {
            this.$v.$touch();
            if(!this.$v.$invalid) {   
                this.loading = true;             
                axios.post("/estructura/agregarEstructura", this.estructura)
                .then(response => {
                    this.$emit('recargaTabla');                                                            
                    this.$store.dispatch('noti',{mensaje: 'Estructura Legal agregada', color:'success'});
                    this.cancelar();
                }).catch(error => {
                  if (error.request && error.request.status === 401) {
                    this.$store.commit('showSessionDialog', true);
                  } else {
                    console.log("Error al agregar estructura legal socios: " + error);
                    this.cancelar();
                    this.$store.dispatch('noti', {mensaje: 'Ocurrió un error no se agregó la estructura legal', color:'error'});
                  }
                })
            }
        }
    },
}
</script>